// キーワード検索で比べる前に文字をそろえる（2026-11-02）
// - 全角英数・記号 → 半角（NFKC）、半角カナ → 全角カナ（NFKC）
// - 英字の大文字 → 小文字
// - カタカナ → ひらがな（「たなか」で「タナカ」も出す）
// - ハイフン類を消す（「09012345678」で「090-1234-5678」も出す）。長音「ー」は消さない
const HYPHENS = /[-‐‑‒–—―−﹣]/g;

export function normalizeSearchText(text: string): string {
  return text
    .normalize("NFKC")
    .toLowerCase()
    .replace(/[\u30a1-\u30f6]/g, (ch) => String.fromCharCode(ch.charCodeAt(0) - 0x60))
    .replace(HYPHENS, "");
}
